module.exports = __webpack_public_path__ + "img/separator4.962080ad.svg";